import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useContext } from 'react';
import { ContainerContext } from '../containers/ContainerContext.js';
var useContainerProps = function useContainerProps(props) {
  return _objectSpread2(_objectSpread2({}, useContext(ContainerContext)), props);
};
export { useContainerProps };